import { AERIE } from './aerie.js';
import { BESTIARY } from './bestiary.js';
import { BOUNTIES_EN } from './bounties.js';
import { ENCOUNTERS } from './encounters.js';
import { FRONT } from './front.js';
import { ITEMS } from './items.js';
import { QUESTS } from './quests.js';
import { SERVER } from './server.js';
import { SHOP } from './shop.js';
import { SOCIAL } from './social.js';
import { STASH } from './stash.js';

/**
 * The English catalogue of the interface (ADR 0069), keyed by the exact
 * French phrase, accents included, as the code writes it. One file per part
 * of the interface, merged here; a phrase missing from all of them shows in
 * French and is listed by `shefiraEnglish()`.
 */
export const EN: Readonly<Record<string, string>> = {
  ...SERVER,
  ...SOCIAL,
  ...ITEMS,
  ...SHOP,
  ...QUESTS,
  ...FRONT,
  ...AERIE,
  ...STASH,
  ...ENCOUNTERS,
  ...BESTIARY,
  ...BOUNTIES_EN,
};
